import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import utils from "../../../../utils/validateScanner"

export default {
	name: 'shipment-summary',
	mixins: [utils],
	components: {
		BasicSelect,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			multiPartGrpId:'',
			isLoadingSearch:false,
			bagIdError:false,
			bagIDErrorMSG:'',
			multiPartGrpIdErrorMSG:'',
			multiPartShipmentDetails:[],
			showTable:false,
			hubid:0,
			multiPartId:'',
			hublist:[],
			shippingId:'',
			shippingIdErrorMSG:'',
			mpsPrintmodal:false,
			showMps :false,
			log:'',
			multiPartGroupIdDetails:[]
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
      // var with2Decimals = val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      // return  with2Decimals
    },
		BagCategory: function(isparentbag){
			if (isparentbag==true) {
				return "Parent";
			}else if(isparentbag==false){
				return "Child";
			}
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.hubid = userdetail[0].HubId[0];
		this.getHubList();

	},
	methods: {
		getHubList() {
			this.hublist = []
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					var HubDetails = result.data.ResponseData
					for (var i = 0; i < HubDetails.length; i++) {
						this.hublist.push({
							"value": HubDetails[i].HubID,
							"text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
						})
					}
				}, error => {
					console.error(error)
				})
		},

		onSubmitSearch: function() {
			var self = this
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
				// this.$alertify.success("your message");
			}).catch(() => {
				console.log('errors exist')
				//this.$alertify.error("your message")
			});
		},

		getMpsDetails(multiPartGroupId){
			this.isLoadingSearch = true;
			this.multiPartGroupIdDetails = [];
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getShipmentsDetailsByMultiPartId?multiPartGroupId=' + multiPartGroupId,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.multiPartId=result.data.MultiPartGroupId;

						var hubDetails = [];
						var logData = [];
						for (var i = 0; i < this.hublist.length; i++) {
							hubDetails[this.hublist[i].value] = this.hublist[i].text;
						}

						if (result.data.ResponseData.length > 0) {
							result.data.ResponseData.forEach(function(item) {
								item["OriginHubName"] = '';
								if (item.OriginHubID && hubDetails[item.OriginHubID]) {
									item["OriginHubName"] = hubDetails[item.OriginHubID];
								}
								item["CurrentLocationName"] = '';
								if (item.CurrentHubID && hubDetails[item.CurrentHubID]) {
									item["CurrentLocationName"] = hubDetails[item.CurrentHubID];
								}
								item["FinalDestinationName"] = '';
								if (item.FinalDestinationID && hubDetails[item.FinalDestinationID]) {
									item["FinalDestinationName"] = hubDetails[item.FinalDestinationID];
								}
								logData.push(item);
							});
						}

						if(this.mpsPrintmodal == true){
							this.multiPartGroupIdDetails = logData;
						}else{
							this.multiPartShipmentDetails = logData;
						}
						this.$alertify.success(result.data.ReturnMessage);
					} else {
						this.isLoadingSearch= false;
						this.$alertify.error(result.data.ReturnMessage);

					}
				}, error => {
					console.error(error)
					this.isLoadingSearch= false;
				})

		},

		getShipmentDetailsMultiPartGroupId() {
			if (this.multiPartGrpId == '' || this.multiPartGrpId == undefined) {
				this.multiPartGrpIdErrorMSG = 'Enter Multi Part GroupId';
				return false;
			}
			this.multiPartShipmentDetails=[];
			this.multiPartGrpIdErrorMSG = '';
			this.showMps = true;

			this.getMpsDetails(this.multiPartGrpId );
			this.showTable = true;

		},

        /*Created new Function for shipment search in Multigroup shipment summary page*/

		getMpsShipmentDetail() {
			if (this.shippingId == '' || this.shippingId == undefined) {
				this.shippingIdErrorMSG = 'Enter Shipment Id';
				return false;
			}
			this.multiPartShipmentDetails =[];
			this.shippingIdErrorMSG  = '';
			this.isLoadingSearch = true;
			this.showMps = false;
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getShipmentDetailsInMps?ShippingID=' + this.shippingId,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						
							if(Object.keys(result.data.lossCategorization).length !=0){
								this.colorCode = result.data.lossCategorization.colorCode;
								this.colorIcon = result.data.lossCategorization.icon;
							}
						this.showTable = true;
                        let shipmentDetailsData = result.data.ResponseData;
						let hubDetails = []
              			for (var i = 0; i < this.hublist.length; i++) {
                				hubDetails[this.hublist[i].value] = this.hublist[i].text;
              			}
              			if (shipmentDetailsData) {
                			shipmentDetailsData.OriginHubName = '';
                		if (shipmentDetailsData.OriginHubID && hubDetails[shipmentDetailsData.OriginHubID]) {
                  	 		shipmentDetailsData.OriginHubName = hubDetails[shipmentDetailsData.OriginHubID];
                		}
                		shipmentDetailsData.CurrentHubName = '';
                		if (shipmentDetailsData.CurrentHubID && hubDetails[shipmentDetailsData.CurrentHubID]) {
                  			shipmentDetailsData.CurrentHubName = hubDetails[shipmentDetailsData.CurrentHubID];
                		}
                		shipmentDetailsData.FinalDestinationName = '';
                		if (shipmentDetailsData.FinalDestinationID && hubDetails[shipmentDetailsData.FinalDestinationID]) {
                  			shipmentDetailsData.FinalDestinationName = hubDetails[shipmentDetailsData.FinalDestinationID];
                		}
						shipmentDetailsData = [shipmentDetailsData];
						this.multiPartShipmentDetails = shipmentDetailsData;
						this.$alertify.success(result.data.ReturnMessage);

					}
				 } else {
					    this.isLoadingSearch= false;
						this.showTable = false;
						this.$alertify.error(result.data.ReturnMessage);
						this.multiPartShipmentDetails = [];
						this.showHideCodeIconInput();
					}

				}, error => {
					console.error(error)
					this.isLoadingSearch= false;
					this.showHideCodeIconInput();
				})
		}
		,

		/* for Mps detail model */

		getMpsPrintDetails(data) {
			this.log = this.multiPartShipmentDetails;
			this.getMpsDetails(data);
			if(this.multiPartShipmentDetails){
                this.mpsPrintmodal = true
				this.showTable=true;
			}
		},
		closeMpsPrintmodal() {
			this.mpsPrintmodal = false
			this.multiPartShipmentDetails = this.log;
			this.showTable= true;
		},

		// showBinLog(multiPartShipmentDetails){
		// 	this.binAuditLog = multiPartShipmentDetails.binAuditLog
		// 	this.showBinAuditLog = true
		// },
		// closeBinAuditLog()
		// {
		// 	this.showBinAuditLog = false
		// 	$(document.body).removeClass("modal-open");
		// 	$(".modal-backdrop").remove();
		// },
		// showBinShipmentLog(){
		// 	this.binShipmentDetails = [];
		// 	axios({
		// 			method: 'GET',
		// 			url: apiUrl.api_url_hubops + 'getBinShipmentDetailsByBinNo?multiPartGrpId=' + this.multiPartGrpId + '&currentHubId='+this.hubid,
		// 			headers: {
		// 				'authorization': 'authkey xB84JJ89Hd25'
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.isLoadingSearch = false;
		// 			if (result.data.ResultCode == 100) {
		// 				this.binShipmentDetails = result.data.ResponseData;
		// 				this.showBinShipmentDetils=true;
		// 			} else {
		// 				this.$alertify.error(result.data.ReturnMessage);
		// 				this.binShipmentDetails = [];
		// 			}
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },
		// closeBinShipmentLog()
		// {
		// 	this.showBinShipmentDetils = false
		// 	$(document.body).removeClass("modal-open");
		// 	$(".modal-backdrop").remove();
		// },

		resetForm(){
		 this.isLoadingSearch= false;
		 this.multiPartGrpIdErrorMSG = '';
		 this.showTable=false;
		 this.multiPartGrpId='';
		 this.$validator.reset();
		 this.shippingId='';
		 this.shippingIdErrorMSG='';
		 this.log = '';
		 this.showHideCodeIconInput();

	 }
	}
}



// WEBPACK FOOTER //
// ./src/views/components/BagShipmentQuery/MultiPartGroupSummary/MultiPartGroupSummary.js